import $ from 'jquery';

const movieModal = () => {
  const $el = $('.js-movieModal');
  if ($el.length < 1) { return; }
  $el.on('click', function(event){
    event.preventDefault();
    const $this  = $(this),
          id     = $this.attr('href'),
          $modal = $(id),
          $body  = $('body');
    const close = () => {
      $modal.fadeOut();
      $('.movieModalBg').fadeOut(function(){
        $(this).remove();
      });
    };
    const open = () => {
      let $bg;
      $body.append('<div class="movieModalBg"></div>');
      $bg = $('.movieModalBg');
      $bg.fadeIn();
      $modal.fadeIn();
      $modal.find('.movieModal_close').on('click', function (event) {
        event.preventDefault();
        close();
      });
      $bg.on('click', function(){
        close();
      });
    };
    open();
  });
};

module.exports = {
  movieModal : movieModal
};




// WEBPACK FOOTER //
// ./src/js/modules/modal.js